import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

import StatusTypeItem from '@components/common/StatusTypeItem/StatusTypeItem';

import useTranslation from '@hooks/useTranslation';

import type { equipmentsTypeNames } from '../../constants/equipmentsTypeNames';
import type { IHardwareOverviewDetailsEquipmentModel } from '../../model/hardwareOverviewDetails';
import { useHODetailsActions } from '../../store/useHODetailsStore';
import style from './style.module.scss';

interface IProps {
  equipmentInfo: IHardwareOverviewDetailsEquipmentModel;
  keyData: keyof typeof equipmentsTypeNames;
}

const equipmentType = {
  gateways: 'gateway',
  repeaters: 'repeater',
  sensorMotes: 'sensor',
  nodes: 'node',
  tetheredSensors: 'sensor',
  tachometers: 'tachometer',
};

const EquipmentCard: React.FC<IProps> = ({ equipmentInfo, keyData }) => {
  const { t } = useTranslation();
  const { customerId } = useParams();
  const { pathname } = useLocation();

  const { setHODetailsLastViewedId } = useHODetailsActions();

  const activeAis = equipmentInfo.activeActionItems || [];
  const activeHardwareAi = !!activeAis.length && activeAis.find((ai) => ai.type === 'waitesWireless');

  const equipmentId =
    equipmentInfo.id || equipmentInfo.router_id || equipmentInfo.gateway_id || equipmentInfo.node_id;
  const equipmentName =
    keyData === 'tetheredSensors' || keyData === 'sensorMotes'
      ? equipmentInfo.equipment_name
      : equipmentInfo.component_name;
  const equipmentHexSerial =
    keyData === 'tetheredSensors' || keyData === 'sensorMotes'
      ? equipmentInfo.sensor_hex
      : equipmentInfo.serial;

  return (
    <Link
      id={`${equipmentId}`}
      className={style.equipmentCard}
      to={`/customer/${customerId}/equipment-details/${equipmentType[keyData]}/${equipmentId}`}
      state={{ prevPage: pathname }}
      onClick={() => setHODetailsLastViewedId(equipmentId)}
    >
      <div className={style.equipmentCardMainInfo}>
        <div className={style.equipmentCardHex}>{equipmentHexSerial}</div>
        {!!activeHardwareAi && (
          <StatusTypeItem item={activeHardwareAi} onlyTitle={true} shortVariant={true} />
        )}
      </div>
      <div className={style.equipmentCardName} data-qa="equipmentCardName">
        {t(equipmentName)}
      </div>
    </Link>
  );
};

export default EquipmentCard;
